// The default lodash debounce function is synchronous, and does not return a promise. This function is an async
// version of debounce that returns a promise.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounceAsync<T, A extends any[]>(
  callback: (...args: A) => Promise<T>,
  wait: number,
): (...args: A) => Promise<T> {
  let timeoutId: number | null = null

  return (...args: A): Promise<T> => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    return new Promise<T>((resolve, reject) => {
      const timeoutPromise = new Promise<void>((resolveTimeout) => {
        timeoutId = window.setTimeout(resolveTimeout, wait)
      })
      timeoutPromise.then(() => {
        callback(...args).then(resolve, reject)
      })
    })
  }
}
